import { render, staticRenderFns } from "./JsonSchemaControl.vue?vue&type=template&id=373f85a0&scoped=true"
import script from "./JsonSchemaControl.vue?vue&type=script&lang=js"
export * from "./JsonSchemaControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373f85a0",
  null
  
)

export default component.exports